import React from 'react';
import Input from '../../../../../components/input/Input';
import { formatNumber } from '../../../../../utils/StringUtil';
import ResultTableSelect from '../../../register/main/components/ResultTableSelect';
import { getAgendaDisplayName, getDivStyle } from '../AgmResult';

const TotalSeparationTable = ({
  data,
  onChangeReuslt,
  onChangeCount,
  isEdit
}) => {
  console.log('SepTable Props');
  console.log(data);
  return (
    <div className="tblcommon-01" style={getDivStyle(data.agenda)}>
      <table>
        <colgroup>
          <col width="*" />
          <col width="*" />
          <col width="*" />
          <col width="*" />
          <col width="*" />
        </colgroup>
        <thead>
          <tr>
            <th colSpan="5" className="title atv">
              {getAgendaDisplayName(data.agenda)}
            </th>
          </tr>
        </thead>
        {data.childs.map((child) => (
          <tbody>
            <tr>
              <th rowSpan="3">{child.agenda.agendaName}</th>
              <th colSpan="4">
                <span className="stock">
                  행사가능 주식수
                  <strong className="ft-col02">
                    {formatNumber(child.agenda.exercisableStockQuantity)}주
                  </strong>
                </span>
              </th>
            </tr>
            <tr>
              <td>찬성</td>
              <td>반대</td>
              <td>기권</td>
              <td rowSpan="2">
                <ResultTableSelect
                  onChange={onChangeReuslt}
                  parentAgendaSeqno={data.agenda.agendaSeqno}
                  agendaSeqno={child.agenda.agendaSeqno}
                  seletcedValue={child.result}
                  disabled={!isEdit}
                  isEdit={isEdit}
                />
              </td>
            </tr>
            <tr>
              <td className="nRight">
                {isEdit ? (
                  <Input
                    type="number"
                    onChange={(e) =>
                      onChangeCount(
                        e.target.value,
                        data.agenda.agendaSeqno,
                        child.agenda.agendaSeqno,
                        'ayesCount'
                      )
                    }
                    value={child.totalValue?.ayesCount}
                  />
                ) : (
                  formatNumber(child.totalValue?.ayesCount)
                )}
              </td>
              <td className="nRight">
                {isEdit ? (
                  <Input
                    type="number"
                    onChange={(e) =>
                      onChangeCount(
                        e.target.value,
                        data.agenda.agendaSeqno,
                        child.agenda.agendaSeqno,
                        'noesCount'
                      )
                    }
                    value={child.totalValue?.noesCount}
                  />
                ) : (
                  formatNumber(child.totalValue?.noesCount)
                )}
              </td>
              <td className="nRight">
                {isEdit ? (
                  <Input
                    type="number"
                    onChange={(e) =>
                      onChangeCount(
                        e.target.value,
                        data.agenda.agendaSeqno,
                        child.agenda.agendaSeqno,
                        'abstentionCount'
                      )
                    }
                    value={child.totalValue?.abstentionCount}
                  />
                ) : (
                  formatNumber(child.totalValue?.abstentionCount)
                )}
              </td>
            </tr>
          </tbody>
        ))}
      </table>
    </div>
  );
};

export default TotalSeparationTable;
